/**
 * @description
 * Constante com configurações de SSO para cada domínio de email
 * a chave corresponde ao domínio do email
 * o valor corresponde as informações de SSO para o domínio
 * caso exista um novo cliente que necessite de SSO, basta adicionar a chave
 * com o domínio do email e o valor com as informações de SSO
 */
export const dadosEmailSAML = {
  '@abaetetuba.itpac.br': {
    urlLogin: {
      producao: 'http://back.pontotel.com.br/api/redirect-saml/front/afya-pontotel',
      homologacao: 'https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/afya-pontotel'
    }
  },
  '@iclinic.com.br': {
    urlLogin: {
      producao: 'http://back.pontotel.com.br/api/redirect-saml/front/afya-pontotel',
      homologacao: 'https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/afya-pontotel'
    }
  },
  '@cliquefarma.com.br': {
    urlLogin: {
      producao: 'http://back.pontotel.com.br/api/redirect-saml/front/afya-pontotel',
      homologacao: 'https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/afya-pontotel'
    }
  },
  '@shosp.com.br': {
    urlLogin: {
      producao: 'http://back.pontotel.com.br/api/redirect-saml/front/afya-pontotel',
      homologacao: 'https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/afya-pontotel'
    }
  },
  '@gliconline.com.br': {
    urlLogin: {
      producao: 'http://back.pontotel.com.br/api/redirect-saml/front/afya-pontotel',
      homologacao: 'https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/afya-pontotel'
    }
  },
  '@afya.com.br': {
    urlLogin: {
      producao: 'http://back.pontotel.com.br/api/redirect-saml/front/afya-pontotel',
      homologacao: 'https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/afya-pontotel'
    }
  },
  '@braganca.itpac.br': {
    urlLogin: {
      producao: 'http://back.pontotel.com.br/api/redirect-saml/front/afya-pontotel',
      homologacao: 'https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/afya-pontotel'
    }
  },
  '@cameta.itpac.br': {
    urlLogin: {
      producao: 'http://back.pontotel.com.br/api/redirect-saml/front/afya-pontotel',
      homologacao: 'https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/afya-pontotel'
    }
  },
  '@cienciasmedicas.com.br': {
    urlLogin: {
      producao: 'http://back.pontotel.com.br/api/redirect-saml/front/afya-pontotel',
      homologacao: 'https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/afya-pontotel'
    }
  },
  '@cienciasmedicaspb.com.br': {
    urlLogin: {
      producao: 'http://back.pontotel.com.br/api/redirect-saml/front/afya-pontotel',
      homologacao: 'https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/afya-pontotel'
    }
  },
  '@cruzeirodosul.itpac.br': {
    urlLogin: {
      producao: 'http://back.pontotel.com.br/api/redirect-saml/front/afya-pontotel',
      homologacao: 'https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/afya-pontotel'
    }
  },
  '@facamedicina.com.br': {
    urlLogin: {
      producao: 'http://back.pontotel.com.br/api/redirect-saml/front/afya-pontotel',
      homologacao: 'https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/afya-pontotel'
    }
  },
  '@facimpa.edu.br': {
    urlLogin: {
      producao: 'http://back.pontotel.com.br/api/redirect-saml/front/afya-pontotel',
      homologacao: 'https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/afya-pontotel'
    }
  },
  '@fameg.com.br': {
    urlLogin: {
      producao: 'http://back.pontotel.com.br/api/redirect-saml/front/afya-pontotel',
      homologacao: 'https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/afya-pontotel'
    }
  },
  '@fesar.edu.br': {
    urlLogin: {
      producao: 'http://back.pontotel.com.br/api/redirect-saml/front/afya-pontotel',
      homologacao: 'https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/afya-pontotel'
    }
  },
  '@fip-gbi.edu.br': {
    urlLogin: {
      producao: 'http://back.pontotel.com.br/api/redirect-saml/front/afya-pontotel',
      homologacao: 'https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/afya-pontotel'
    }
  },
  '@fmit.edu.br': {
    urlLogin: {
      producao: 'http://back.pontotel.com.br/api/redirect-saml/front/afya-pontotel',
      homologacao: 'https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/afya-pontotel'
    }
  },
  '@iesvap.edu.br': {
    urlLogin: {
      producao: 'http://back.pontotel.com.br/api/redirect-saml/front/afya-pontotel',
      homologacao: 'https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/afya-pontotel'
    }
  },
  '@ipemed.edu.br': {
    urlLogin: {
      producao: 'http://back.pontotel.com.br/api/redirect-saml/front/afya-pontotel',
      homologacao: 'https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/afya-pontotel'
    }
  },
  '@iptan.edu.br': {
    urlLogin: {
      producao: 'http://back.pontotel.com.br/api/redirect-saml/front/afya-pontotel',
      homologacao: 'https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/afya-pontotel'
    }
  },
  '@itabuna.fasa.edu.br': {
    urlLogin: {
      producao: 'http://back.pontotel.com.br/api/redirect-saml/front/afya-pontotel',
      homologacao: 'https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/afya-pontotel'
    }
  },
  '@itacoatiara.itpac.br': {
    urlLogin: {
      producao: 'http://back.pontotel.com.br/api/redirect-saml/front/afya-pontotel',
      homologacao: 'https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/afya-pontotel'
    }
  },
  '@itpac.br': {
    urlLogin: {
      producao: 'http://back.pontotel.com.br/api/redirect-saml/front/afya-pontotel',
      homologacao: 'https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/afya-pontotel'
    }
  },
  '@itpacpalmas.com.br': {
    urlLogin: {
      producao: 'http://back.pontotel.com.br/api/redirect-saml/front/afya-pontotel',
      homologacao: 'https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/afya-pontotel'
    }
  },
  '@itpacporto.com.br': {
    urlLogin: {
      producao: 'http://back.pontotel.com.br/api/redirect-saml/front/afya-pontotel',
      homologacao: 'https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/afya-pontotel'
    }
  },
  '@itpacporto.edu.br': {
    urlLogin: {
      producao: 'http://back.pontotel.com.br/api/redirect-saml/front/afya-pontotel',
      homologacao: 'https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/afya-pontotel'
    }
  },
  '@manacapuru.itpac.br': {
    urlLogin: {
      producao: 'http://back.pontotel.com.br/api/redirect-saml/front/afya-pontotel',
      homologacao: 'https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/afya-pontotel'
    }
  },
  '@medcel.com.br': {
    urlLogin: {
      producao: 'http://back.pontotel.com.br/api/redirect-saml/front/afya-pontotel',
      homologacao: 'https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/afya-pontotel'
    }
  },
  '@naspp.org.br': {
    urlLogin: {
      producao: 'http://back.pontotel.com.br/api/redirect-saml/front/afya-pontotel',
      homologacao: 'https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/afya-pontotel'
    }
  },
  '@parceiro.afya.com.br': {
    urlLogin: {
      producao: 'http://back.pontotel.com.br/api/redirect-saml/front/afya-pontotel',
      homologacao: 'https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/afya-pontotel'
    }
  },
  '@pdcsaude.com.br': {
    urlLogin: {
      producao: 'http://back.pontotel.com.br/api/redirect-saml/front/afya-pontotel',
      homologacao: 'https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/afya-pontotel'
    }
  },
  '@pebmed.com.br': {
    urlLogin: {
      producao: 'http://back.pontotel.com.br/api/redirect-saml/front/afya-pontotel',
      homologacao: 'https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/afya-pontotel'
    }
  },
  '@santaines.itpac.br': {
    urlLogin: {
      producao: 'http://back.pontotel.com.br/api/redirect-saml/front/afya-pontotel',
      homologacao: 'https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/afya-pontotel'
    }
  },
  '@saolucas.edu.br': {
    urlLogin: {
      producao: 'http://back.pontotel.com.br/api/redirect-saml/front/afya-pontotel',
      homologacao: 'https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/afya-pontotel'
    }
  },
  '@saolucasjiparana.edu.br': {
    urlLogin: {
      producao: 'http://back.pontotel.com.br/api/redirect-saml/front/afya-pontotel',
      homologacao: 'https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/afya-pontotel'
    }
  },
  '@sete.fasa.edu.br': {
    urlLogin: {
      producao: 'http://back.pontotel.com.br/api/redirect-saml/front/afya-pontotel',
      homologacao: 'https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/afya-pontotel'
    }
  },
  '@unidep.edu.br': {
    urlLogin: {
      producao: 'http://back.pontotel.com.br/api/redirect-saml/front/afya-pontotel',
      homologacao: 'https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/afya-pontotel'
    }
  },
  '@unifipmoc.edu.br': {
    urlLogin: {
      producao: 'http://back.pontotel.com.br/api/redirect-saml/front/afya-pontotel',
      homologacao: 'https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/afya-pontotel'
    }
  },
  '@unigranrio.com.br': {
    urlLogin: {
      producao: 'http://back.pontotel.com.br/api/redirect-saml/front/afya-pontotel',
      homologacao: 'https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/afya-pontotel'
    }
  },
  '@unima.edu.br': {
    urlLogin: {
      producao: 'http://back.pontotel.com.br/api/redirect-saml/front/afya-pontotel',
      homologacao: 'https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/afya-pontotel'
    }
  },
  '@uninovafapi.edu.br': {
    urlLogin: {
      producao: 'http://back.pontotel.com.br/api/redirect-saml/front/afya-pontotel',
      homologacao: 'https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/afya-pontotel'
    }
  },
  '@uniptan.edu.br': {
    urlLogin: {
      producao: 'http://back.pontotel.com.br/api/redirect-saml/front/afya-pontotel',
      homologacao: 'https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/afya-pontotel'
    }
  },
  '@uniredentor.edu.br': {
    urlLogin: {
      producao: 'http://back.pontotel.com.br/api/redirect-saml/front/afya-pontotel',
      homologacao: 'https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/afya-pontotel'
    }
  },
  '@unitpac.edu.br': {
    urlLogin: {
      producao: 'http://back.pontotel.com.br/api/redirect-saml/front/afya-pontotel',
      homologacao: 'https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/afya-pontotel'
    }
  },
  '@univaco.edu.br': {
    urlLogin: {
      producao: 'http://back.pontotel.com.br/api/redirect-saml/front/afya-pontotel',
      homologacao: 'https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/afya-pontotel'
    }
  },
  '@vic.fasa.edu.br': {
    urlLogin: {
      producao: 'http://back.pontotel.com.br/api/redirect-saml/front/afya-pontotel',
      homologacao: 'https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/afya-pontotel'
    }
  },
  '@bv.com.br': {
    urlLogin: {
      producao: 'https://back.pontotel.com.br/api/redirect-saml/front/BancoVotorantim',
      homologacao: 'https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/BancoVotorantim'
    }
  },
  '@bvia.com.br': {
    urlLogin: {
      producao: 'https://back.pontotel.com.br/api/redirect-saml/front/BancoVotorantim',
      homologacao: 'https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/BancoVotorantim'
    }
  },
  '@votorantimfinancas.com.br': {
    urlLogin: {
      producao: 'https://back.pontotel.com.br/api/redirect-saml/front/BancoVotorantim',
      homologacao: 'https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/BancoVotorantim'
    }
  },
  '@redepromotiva.com.br': {
    urlLogin: {
      producao: 'https://back.pontotel.com.br/api/redirect-saml/front/BancoVotorantim',
      homologacao: 'https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/BancoVotorantim'
    }
  },
  '@deutschepost.de': {
    urlLogin: {
      producao: 'http://back.pontotel.com.br/api/redirect-saml/front/dhl-pontotel',
      homologacao: 'https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/dhl-pontotel'
    }
  },
  '@dhl.com': {
    urlLogin: {
      producao: 'http://back.pontotel.com.br/api/redirect-saml/front/dhl-pontotel',
      homologacao: 'https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/dhl-pontotel'
    }
  },
  '@dpdhl.com': {
    urlLogin: {
      producao: 'http://back.pontotel.com.br/api/redirect-saml/front/dhl-pontotel',
      homologacao: 'https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/dhl-pontotel'
    }
  },
  '@mydpdhl.com': {
    urlLogin: {
      producao: 'http://back.pontotel.com.br/api/redirect-saml/front/dhl-pontotel',
      homologacao: 'https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/dhl-pontotel'
    }
  },
  '@modal.com.br': {
    urlLogin: {
      producao: 'http://back.pontotel.com.br/api/redirect-saml/front/xp',
      homologacao: 'https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/xp'
    }
  },
  '@modalmais.com.br': {
    urlLogin: {
      producao: 'http://back.pontotel.com.br/api/redirect-saml/front/xp',
      homologacao: 'https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/xp'
    }
  },
  '@xpi.com.br': {
    urlLogin: {
      producao: 'https://back.pontotel.com.br/api/redirect-saml/front/xp',
      homologacao: 'https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/xp'
    },
    urlLoginBatepontoWeb: {
      producao: 'https://back.pontotel.com.br/api/redirect-saml/bateponto/xp',
      homologacao: 'https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/bateponto/xp'
    }
  },
  '@xpasset.com.br': {
    urlLogin: {
      producao: 'http://back.pontotel.com.br/api/redirect-saml/front/xp',
      homologacao: 'https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/xp'
    }
  },
  '@xpadvisory.com.br': {
    urlLogin: {
      producao: 'http://back.pontotel.com.br/api/redirect-saml/front/xp',
      homologacao: 'https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/xp'
    }
  },
  '@xpi.us': {
    urlLogin: {
      producao: 'http://back.pontotel.com.br/api/redirect-saml/front/xp',
      homologacao: 'https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/xp'
    }
  },
  '@infomoney.com.br': {
    urlLogin: {
      producao: 'http://back.pontotel.com.br/api/redirect-saml/front/xp',
      homologacao: 'https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/xp'
    }
  },
  '@xpcs.com.br': {
    urlLogin: {
      producao: 'http://back.pontotel.com.br/api/redirect-saml/front/xp',
      homologacao: 'https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/xp'
    }
  },
  '@rico.com.vc': {
    urlLogin: {
      producao: 'http://back.pontotel.com.br/api/redirect-saml/front/xp',
      homologacao: 'https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/xp'
    }
  },
  '@xpprivate.com': {
    urlLogin: {
      producao: 'http://back.pontotel.com.br/api/redirect-saml/front/xp',
      homologacao: 'https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/xp'
    }
  },
  '@clear.com.br': {
    urlLogin: {
      producao: 'http://back.pontotel.com.br/api/redirect-saml/front/xp',
      homologacao: 'https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/xp'
    }
  },
  '@tecfinance.com.br': {
    urlLogin: {
      producao: 'http://back.pontotel.com.br/api/redirect-saml/front/xp',
      homologacao: 'https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/xp'
    }
  },
  '@grupobrasanitas.com.br': {
    urlLogin: {
      producao: 'https://back.pontotel.com.br/api/redirect-saml/front/brasanitas-pontotel',
      homologacao: 'https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/brasanitasteste'
    }
  },
  '@cora.com.br': {
    urlLogin: {
      producao: 'https://back.pontotel.com.br/api/redirect-saml/front/cora-pontotel',
      homologacao: 'https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/coratecnologia'
    }
  },
  '@voke.tech': {
    urlLogin: {
      producao: 'https://back.pontotel.com.br/api/redirect-saml/front/voke-pontotel',
      homologacao: 'https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/voke-pontotel'
    },
    urlLoginBatepontoWeb: {
      producao: 'https://back.pontotel.com.br/api/redirect-saml/bateponto/voke-pontotel',
      homologacao: 'https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/bateponto/voke-pontotel'
    }
  },
  '@willbank.com.br': {
    urlLogin: {
      producao: 'https://back.pontotel.com.br/api/redirect-saml/front/willbank-pontotel',
      homologacao: 'https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/willbank-pontotel'
    },
    urlLoginBatepontoWeb: {
      producao: 'https://back.pontotel.com.br/api/redirect-saml/bateponto/willbank-pontotel',
      homologacao: 'https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/bateponto/willbank-pontotel'
    }
  },
  '@pontotel.com.br': {
    urlLoginBatepontoWeb: {
      producao: 'https://bateponto.pontotel.com.br/#/',
      homologacao: 'https://hml.pontotel.com.br/pontotel/bateponto/#/'
    }
  },
  '@ssointerno.com.br': {
    urlLogin: {
      producao: 'https://prod.pontotel.com.br/pontotel/back/api/redirect-saml/front/monitoramento-pontotel',
      homologacao: 'https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/monitoramento-pontotel'
    },
    urlLoginBatepontoWeb: {
      producao: 'https://prod.pontotel.com.br/pontotel/back/api/redirect-saml/bateponto/monitoramento-pontotel',
      homologacao: 'https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/bateponto/monitoramento-pontotel'
    }
  },
  '@vibraenergia.com.br': {
    urlLogin: {
      producao: 'http://back.pontotel.com.br/api/redirect-saml/front/vibra-pontotel',
      homologacao: 'https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/vibra-pontotel'
    },
    urlLoginBatepontoWeb: {
      producao: 'http://back.pontotel.com.br/api/redirect-saml/bateponto/vibra-pontotel',
      homologacao: 'https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/bateponto/vibra-pontotel'
    }
  },
  '@gs.com': {
    urlLogin: {
      producao: 'https://back.pontotel.com.br/api/redirect-saml/front/gs-pontotel',
      homologacao: 'https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/front/gs-pontotel'
    },
    urlLoginBatepontoWeb: {
      producao: 'https://back.pontotel.com.br/api/redirect-saml/bateponto/gs-pontotel',
      homologacao: 'https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/bateponto/gs-pontotel'
    }
  }
}
